import React, { Component } from 'react';

import { Region } from 'C4';

const avatar = 'https://front.travpromobile.com/743/avatar_unknown.svg';

const regions = {
  australia: {
    name: 'Australia',
    offices: [
      {
        office: 'sydney',
        salesRegion: 'Australia & New Zealand',
        adressLines: [
          'Suite 12.02, Level 12',
          '227 Elizabeth Street',
          'Sydney 2000, NSW, Australia',
        ],
        contacts: [
          {
            id: 1,
            name: 'Craig Adamson',
            description: 'Managing Director, Asia Pacific (excl. China)',
            telephone: '61 2 9377 8400',
            mail: 'cadamson@lhw.com',
            imageUrl:
              'https://front.travpromobile.com/743/Laura%20Hildmann%20-%20Craig%20Adamson.Jpg',
          },
          {
            id: 2,
            name: 'Renee Fowler',
            description: 'Associate Manager, Sales',
            telephone: '61 2 9377 8400',
            mail: 'rfowler@lhw.com',
            town: 'sydney',
            imageUrl:
              'https://front.travpromobile.com/743/Laura%20Hildmann%20-%20ReneeFowler.jpg',
          },
        ],
      },
    ],
  },
  asia: {
    name: 'Asia',
    offices: [
      {
        office: 'Tokyo',
        salesRegion: 'Japan',
        adressLines: [
          '2F, 1-3-27 Shimomeguro, Merugo-ku',
          'Tokyo 153-0064, Japan',
        ],
        contacts: [
          {
            name: 'Shingo Hirao',
            description: 'Director, Japan',
            telephone: '81 3 5436 8115',
            mail: 'shirao@lhw.com',
            imageUrl: 'https://front.travpromobile.com/743/shingo.png',
          },
        ],
      },
      {
        office: 'Seoul',
        salesRegion: 'Korea',
        adressLines: [
          '16F, Tower 8',
          '7 Jongro 5-gil, Jongro-gu',
          'Seoul 03157, Korea',
        ],
        contacts: [
          {
            name: 'Richard Kim',
            description: 'Director, Korea',
            telephone: '82 2 6226 7228',
            mail: 'rkim@lhw.com',
            imageUrl: avatar,
          },
        ],
      },
      {
        office: 'Singapore',
        salesRegion: 'South East Asia',
        adressLines: [
          '3 Temasek Avenue',
          '#24-06 Centennial Tower',
          'Singapore 039190',
        ],
        contacts: [
          {
            name: 'Sathia Moorthy',
            description: 'Director, South East Asia',
            telephone: '65 6737 6696',
            mail: 'smoorthy@lhw.com',
            imageUrl: avatar,
          },
          {
            name: 'Stephanie Neubronner',
            description: 'Manager, South East Asia',
            telephone: '65 6737 6696',
            mail: 'sneubronner@lhw.com',
            imageUrl: 'https://front.travpromobile.com/743/stephanie.png',
          },
        ],
      },
      {
        office: 'Greater China',
        salesRegion: 'Greater China',
        adressLines: [
          'Suite 342, Shanghai Center',
          '1376 Nanjing Road West',
          'Shanghai 200040, China',
        ],
        contacts: [
          {
            name: 'Fiza Han',
            description: 'Managing Director, China',
            telephone: '86 21 6279 8951',
            mail: 'fhan@lhw.com',
            imageUrl: 'https://front.travpromobile.com/743/fiza.png',
          },
          {
            name: 'Candy Chen',
            description: 'Director of Sales - Eastern China',
            telephone: '86 21 6279 8951',
            mail: 'cchen@lhw.com',
            imageUrl: 'https://front.travpromobile.com/743/candy.png',
          },
          {
            name: 'Michael Xu',
            description: 'Senior Sales Manager - Eastern China',
            telephone: '86 21 6279 8951',
            mail: 'mxu@lhw.com',
            imageUrl: 'https://front.travpromobile.com/743/michael.png',
          },
          {
            name: 'Angelina An',
            description: 'Senior Sales Manager - Northern China',
            telephone: '86 21 6279 8951',
            mail: 'aan@lhw.com',
            imageUrl: 'https://front.travpromobile.com/743/angelina.png',
          },
          {
            name: 'Alan Wang',
            description: 'Senior Sales Manager - Western China',
            telephone: '86 21 6279 8951',
            mail: 'awang@lhw.com',
            imageUrl:
              'https://front.travpromobile.com/743/Laura%20Hildmann%20-%20Alan%20Wang.jpg',
          },
        ],
      },
      {
        office: 'Hong Kong',
        salesRegion: 'Hong Kong & Taiwan',
        adressLines: [
          'Suite 1017, 10/F',
          'Sun House',
          '181 Des Voeux Road Central, Hong Kong',
        ],
        contacts: [
          {
            name: 'Fiza Han',
            description: 'Managing Director, China',
            telephone: '852 2191 9696',
            mail: 'fhan@lhw.com',
            imageUrl: 'https://front.travpromobile.com/743/fiza.png',
          },
          {
            name: 'Carol Leung',
            description: 'Senior Sales Manager - Hong Kong & Taiwan',
            telephone: '852 2191 9696',
            mail: 'cleung@lhw.com',
            imageUrl: 'https://front.travpromobile.com/743/carol.png',
          },
        ],
      },
      {
        office: 'India',
        salesRegion: 'India',
        adressLines: [],
        contacts: [
          {
            name: 'Deepak Arora',
            description: 'Managing Director, China',
            telephone: '91 22 40779214 / 9234',
            mail: 'darora@lhw.com',
            imageUrl:
              'https://front.travpromobile.com/743/Laura%20Hildmann%20-%20Deepak%20Arora.JPG',
          },
        ],
      },
    ],
  },
  samer: {
    name: 'South America',
    offices: [
      {
        office: 'São Paulo',
        salesRegion: 'Brazil',
        adressLines: [
          'Al. Santos 1773',
          'Suite 1207',
          '01419-002 São paulo SP',
          'Brazil',
        ],
        contacts: [
          {
            name: 'João Annibale',
            description: 'Senior Regional Director, Brazil',
            telephone: '',
            mail: 'jannibale@lhw.com ',
            imageUrl: 'https://front.travpromobile.com/743/joao.png',
          },
          {
            name: 'Francesco Ferraro',
            description: 'Senior Manager, Sales',
            telephone: '',
            mail: 'fferraro@lhw.com',
            imageUrl: 'https://front.travpromobile.com/743/francesco.png',
          },
          {
            name: 'Giovana Mikelaitis',
            description: 'Senior Manager, Corporate Sales',
            telephone: '',
            mail: 'gmikelaitis@lhw.com',
            imageUrl: 'https://front.travpromobile.com/743/giovana.png',
          },
          {
            name: 'George Chiminazzo',
            description: 'Manager, Sales',
            telephone: '',
            mail: 'gchiminazzo@lhw.com',
            imageUrl: 'https://front.travpromobile.com/743/george.png',
          },
        ],
      },
      {
        office: 'Buenos Aires',
        salesRegion: 'Spanish Speaking Countries in Latin America',
        adressLines: [
          'Esmeralda 920, Of.2706',
          'C1007ABL Buenos Aires',
          'Argentina',
        ],
        contacts: [
          {
            name: 'Daniela Shayo',
            description:
              'Senior Director Argentina-Mexico & Latin America Spanish speaking countries',
            telephone: '54 11 7078 0080',
            mail: 'dshayo@lhw.com ',
            imageUrl:
              'https://front.travpromobile.com/743/Laura%20Hildmann%20-%20Daniela%20Shayo.jpg',
          },
          {
            name: 'Enrique Espinosa Solar',
            description: 'Senior Sales Manager',
            telephone: '54 11 7078 0080',
            mail: 'esolar@lhw.com ',
            imageUrl:
              'https://front.travpromobile.com/743/Laura%20Hildmann%20-%20Enrique%20Espinosa%20Solar.jpg',
          },
          {
            name: 'Cecilia Attwell',
            description: 'Sales Manager',
            telephone: '54 11 7078 0080',
            mail: 'cattwell@lhw.com',
            imageUrl:
              'https://front.travpromobile.com/743/Laura%20Hildmann%20-%20Cecilia%20Attwell.jpg',
          },
        ],
      },
      {
        office: 'Mexico',
        salesRegion: 'Mexico',
        adressLines: [
          'Juan Vazquez de Mella 481, Piso 2, Oficina 200A Col. Los Morales Polanco, Miguel Hidalgo 11510, Ciudad de México',
          'Piso 2, Oficina 200A',
          'Col. Los Morales Polanco, Miguel Hidalgo',
          '11510, Ciudad de México',
        ],
        contacts: [
          {
            name: 'Daniela Shayo',
            description:
              'Senior Director Argentina-Mexico & Latin America Spanish speaking countries',
            telephone: '54 11 7078 0080',
            mail: 'dshayo@lhw.com ',
            imageUrl:
              'https://front.travpromobile.com/743/Laura%20Hildmann%20-%20Daniela%20Shayo.jpg',
          },
          {
            name: 'Yamile Felix',
            description: 'Senior Sales Manager',
            telephone: '52 55 2122 2771',
            mail: 'yfelix@lhw.com ',
            imageUrl:
              'https://front.travpromobile.com/743/Laura%20Hildmann%20-%20Yamile%20Felix.jpg',
          },
        ],
      },
    ],
  },
  namer: {
    name: 'North America',
    offices: [
      {
        office: 'Los Angeles',
        salesRegion: 'Western Region',
        adressLines: [],
        contacts: [
          {
            name: 'Remy Papazian',
            description: 'Director Travel Trade Western Region',
            telephone: '1 310 576 7098',
            mail: 'rpapazian@lhw.com',
            imageUrl: 'https://front.travpromobile.com/743/remy.png',
          },
          {
            name: 'Caitlin Murphy',
            description: 'Senior Manager Travel Trade Western Region',
            telephone: '1 310 576 7098',
            mail: 'cmurphy@lhw.com',
            imageUrl:
              'https://front.travpromobile.com/743/Laura%20Hildmann%20-%20Caitlin%20Murphy.jpg',
          },
          {
            name: 'Svetlana Thein',
            description: 'Specialist Entertainment Sales',
            telephone: '1 310 576 7098',
            mail: 'sthein@lhw.com',
            imageUrl: 'https://front.travpromobile.com/743/Svetlana+Thein.jpg',
          },
        ],
      },
      {
        office: 'New York City',
        salesRegion: 'Eastern Region and Canada',
        adressLines: [
          '485 Lexington Avenue',
          'New York, New York 10017 U.S.A.',
        ],
        contacts: [
          {
            name: 'Dennis Grunden',
            description: 'Director Travel Trade Eastern Region',
            telephone: '1 212 515 5600',
            mail: 'dgrunden@lhw.com',
            imageUrl: 'https://front.travpromobile.com/743/dennis.png',
          },
          {
            name: 'Catherine Johns',
            description: 'Senior Manager Travel Trade Eastern Region',
            telephone: '1 212 515 5600',
            mail: 'cjohns@lhw.com',
            imageUrl: 'https://front.travpromobile.com/743/catherine.png',
          },
          {
            name: 'Amrin Gilani',
            description: 'Senior Coordinator, Travel Trade',
            telephone: '1 212 515 5600',
            mail: 'agilani@lhw.com',
            imageUrl: 'https://front.travpromobile.com/743/amrin.png',
          },
        ],
      },
    ],
  },
  europe: {
    name: 'Europe',
    offices: [
      {
        office: 'London',
        salesRegion: 'UK, Ireland, Nordics, Portugal & Spain',
        adressLines: [],
        contacts: [
          {
            name: 'Marie-Pierre Morelle',
            description: 'Director Travel Trade – EUROPE | Paris Office',
            telephone: '33 1 53 67 10 10',
            mail: 'mpmorelle@lhw.com',
            imageUrl:
              'https://front.travpromobile.com/743/Laura%20Hildmann%20-%20Marie-Pierre%20Morelle.jpg',
          },
          {
            name: 'Giuseppe Paturzo',
            description: 'Director Travel Trade and Entertainment, UK & Italy',
            telephone: '33 1 53 67 10 10',
            mail: 'gpaturzo@lhw.com',
            imageUrl: 'https://front.travpromobile.com/743/giuseppe.png',
          },
        ],
      },
      {
        office: 'Paris',
        salesRegion: 'France, Monaco & Benelux',
        adressLines: [
          'KWERK Haussmann',
          '29-31, rue de Courcelles',
          '75008 Paris, France',
        ],
        contacts: [
          {
            name: 'Marie-Pierre Morelle',
            description: 'Director Travel Trade – EUROPE | Paris Office',
            telephone: '33 1 53 67 10 10',
            mail: 'mpmorelle@lhw.com',
            imageUrl:
              'https://front.travpromobile.com/743/Laura%20Hildmann%20-%20Marie-Pierre%20Morelle.jpg',
          },
          {
            name: 'Giuseppe Paturzo',
            description: 'Director Travel Trade and Entertainment, UK & Italy',
            telephone: '33 1 53 67 10 10',
            mail: 'gpaturzo@lhw.com',
            imageUrl: 'https://front.travpromobile.com/743/giuseppe.png',
          },
        ],
      },
      {
        office: 'Frankfurt',
        salesRegion: 'Germany, Switzerland, Austria & Central Eastern Europe',
        adressLines: ['Berliner Strasse 44', '60311 Frankfurt, Germany'],
        contacts: [
          {
            name: 'Marie-Pierre Morelle',
            description: 'Director Travel Trade – EUROPE | Paris Office',
            telephone: '49 69 138 85 100',
            mail: 'mpmorelle@lhw.com',
            imageUrl:
              'https://front.travpromobile.com/743/Laura%20Hildmann%20-%20Marie-Pierre%20Morelle.jpg',
          },
          {
            name: 'Giuseppe Paturzo',
            description: 'Director Travel Trade and Entertainment, UK & Italy',
            telephone: '49 69 138 85 100',
            mail: 'gpaturzo@lhw.com',
            imageUrl: 'https://front.travpromobile.com/743/giuseppe.png',
          },
        ],
      },
      {
        office: 'Milan',
        salesRegion: 'Italy and Southeast Europe',
        adressLines: ['Via Manuzio, 7', '20124 Milan, Italy'],
        contacts: [
          {
            name: 'Marie-Pierre Morelle',
            description: 'Director Travel Trade – EUROPE | Paris Office',
            telephone: '39 02 669 86131',
            mail: 'mpmorelle@lhw.com',
            imageUrl:
              'https://front.travpromobile.com/743/Laura%20Hildmann%20-%20Marie-Pierre%20Morelle.jpg',
          },
          {
            name: 'Giuseppe Paturzo',
            description: 'Director Travel Trade and Entertainment, UK & Italy',
            telephone: '39 02 669 86131',
            mail: 'gpaturzo@lhw.com',
            imageUrl: 'https://front.travpromobile.com/743/giuseppe.png',
          },
        ],
      },
      {
        office: 'Moscow',
        salesRegion: 'Russia, Ukraine & CIS',
        adressLines: ['Pushkarev lane 9', '127051 Moscow, Russia'],
        contacts: [
          {
            name: 'Valeri Ishunkin',
            description:
              'Senior Director - Eastern Europe, Russia, Ukraine, CIS and Israel',
            telephone: '7 495 933 28 21',
            mail: 'vishunkin@lhw.com',
            imageUrl: 'https://front.travpromobile.com/743/valeri.png',
          },
          {
            name: 'Natalia Vedishcheva',
            description:
              'Senior Sales Manager - Eastern Europe, Russia, Ukraine, CIS and Israel ',
            telephone: '7 495 933 28 21',
            mail: 'nvedishcheva@lhw.com',
            imageUrl: 'https://front.travpromobile.com/743/natalia.png',
          },
        ],
      },
    ],
  },
  mea: {
    // Middle-east and africa
    name: 'Middle East and Africa',
    offices: [
      {
        office: 'Dubai',
        salesRegion: 'Middle East & Africa',
        adressLines: [
          'Knowledge Village',
          'Al Sufouh Road',
          'Block 19, Office Number T14 (03rd floor)',
          'Dubai, United Arab Emirates',
        ],
        contacts: [
          {
            name: 'Hatem Chatter',
            description: 'Senior Director, Middle East & Africa',
            telephone: '971 4 366 1255 ',
            mail: 'hchatter@lhw.com ',
            imageUrl: 'https://front.travpromobile.com/743/hatem.png',
          },
          {
            name: 'Gazafi EL Sheikh',
            description: 'Sales Manager, KSA & Qatar',
            telephone: '971 4 366 1255 ',
            mail: 'gsheikh@lhw.com ',
            imageUrl: 'https://front.travpromobile.com/743/gazaf.png',
          },
          {
            name: 'Mélissa Semaan',
            description: 'Sales Manager, UAE',
            telephone: '971 4 366 1255 ',
            mail: 'msemaan@lhw.com',
            imageUrl: 'https://front.travpromobile.com/743/melissa.png',
          },
        ],
      },
    ],
  },
};

const returnRegion = region => {
  const { asia, samer, namer, europe, australia, mea } = regions;
  switch (region) {
    case 'namer':
      return <Region name={namer.name} offices={namer.offices} />;
    case 'samer':
      return <Region name={samer.name} offices={samer.offices} />;
    case 'europe':
      return <Region name={europe.name} offices={europe.offices} />;
    case 'australia':
      return <Region name={australia.name} offices={australia.offices} />;
    case 'mea':
      return <Region name={mea.name} offices={mea.offices} />;
    case 'asia':
      return <Region name={asia.name} offices={asia.offices} />;
    default:
      return <p>Please Select a region</p>;
  }
};
export default class ContactView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedRegion: 'namer',
    };
  }

  handleSelectRegion = region => {
    this.setState(state => ({
      selectedRegion: region,
    }));
  };

  render() {
    const { selectedRegion } = this.state;
    const params = new URLSearchParams(window.location.search);

    return (
      <div className='contentContainer contact'>
        <div className='contacts'>
          <button
            onClick={() => this.handleSelectRegion('namer')}
            className='button'
          >
            <h1 className='head'>North-America</h1>
          </button>
          <button
            onClick={() => this.handleSelectRegion('samer')}
            className='button'
          >
            <h1 className='head'>South-America</h1>
          </button>
          <button
            onClick={() => this.handleSelectRegion('europe')}
            className='button'
          >
            <h1 className='head'>Europe</h1>
          </button>
          <button
            onClick={() => this.handleSelectRegion('asia')}
            className='button'
          >
            <h1 className='head'>Asia</h1>
          </button>
          <button
            onClick={() => this.handleSelectRegion('mea')}
            className='button'
          >
            <h1 className='head'>Middle-East and Africa</h1>
          </button>
        </div>
        <div className='contactView__Header' />
        <div className='contacts contactItems'>
          {returnRegion(selectedRegion)}
        </div>
        {params.get('header') === 'false' && (
          <style>
            {
              '\
        .header { display: none; } .contact { margin-top: 0rem !important; }'
            }
          </style>
        )}
      </div>
    );
  }
}
